module.exports = __webpack_public_path__ + "files/c01043eb28fbfca022cf422e193d90ea.png";